import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Reveal } from '../Reveal';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq-titulo" className="w-full bg-crema px-4 py-16 sm:px-6 sm:py-20" data-id="element-102" data-mp="x53ex5bncddd">
      <div className="mx-auto max-w-3xl" data-id="element-103" data-mp="122vemlij93s4">
        <Reveal data-id="element-104" data-mp="1pshe7a2thl0n">
          <h2 id="faq-titulo" className="text-center font-display text-3xl font-bold text-bordo sm:text-4xl" data-id="element-105" data-mp="1prxsdia1qchc">
            Preguntas Frecuentes
          </h2>
        </Reveal>

        <div className="mt-10 space-y-3" data-id="element-106" data-mp="1g2edenpgf2rr">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return <Reveal key={faq.pregunta} delay={Math.min(index, 4) * 0.03} data-id="element-107" data-mp="28pimb3ro418t" data-mpi={index}>
                <div className="overflow-hidden rounded-2xl border border-black/5 bg-white shadow-soft" data-id="element-108" data-mp="2ditrl0gu09ym">
                  <h3 data-id="element-109" data-mp="2or0fnatr54qw">
                    <button type="button" id={buttonId} aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left transition-colors hover:bg-grisclaro sm:px-7" data-id="element-110" data-mp="2oqiatpt0xi7d">
                      <span className="text-sm font-bold text-tinta sm:text-base" data-id="element-111" data-mp="32hvsey7dg5zr">{faq.pregunta}</span>
                      <ChevronDown className={`h-5 w-5 shrink-0 text-bordo transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-112" data-mp="3hemi2fr8u3c6" />
                    </button>
                  </h3>
                  <div id={panelId} role="region" aria-labelledby={buttonId} className={`grid transition-all duration-300 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-113" data-mp="1i33ll0n4mnje">
                    <div className="overflow-hidden" data-id="element-114" data-mp="2lpp69knhbmd7">
                      <p className="px-5 pb-6 text-sm leading-relaxed text-tintasuave sm:px-7 sm:text-base" data-id="element-115" data-mp="2lqi8c8bhtnp0">
                        {faq.respuesta}
                      </p>
                    </div>
                  </div>
                </div>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}